import React, { Component, Fragment } from 'react';
class Advance extends Component {
	render() {
		return <Fragment />;
	}
}

export default Advance;
